import CuentaRepository from "@/services/CuentaRepository";

export default {
  namespaced: true,
  state: {
    saldoInicialDetalle: 0,
    saldoFinalDetalle: 0,
    movimientosDetalle: [],

    saldoInicialResumen: 0,
    saldoFinalResumen: 0,
    movimientosResumen: [],

    saldoInicialAnual: 0,
    saldoFinalAnual: 0,
    movimientosAnual: [],
    totalCredito: 0,
    totalDebito: 0,

    chartDetalleLabels: [],
    detalleChartActual: null,
    detalleDebitoActual: null,
    detalleCreditoActual: null,
    detalleCreditoAnterior: null,
    detalleDebitoAnterior: null,
    detalleChartAnterior: null,

    chartResumenMensualCreditoLables: [],
    chartResumenMensualDebitoLables: [],
    chartResumenMensualCreditoChart: null,
    chartResumenMensualDebitoChart: null,

    chartResumenAnualCreditoLables: [],
    chartResumenAnualDebitoLables: [],
    chartResumenAnualCreditoChart: null,
    chartResumenAnualDebitoChart: null,
  },
  mutations: {
    setDetalle(state, detalle) {
      state.saldoInicialDetalle = detalle.saldoInicial;
      state.saldoFinalDetalle = detalle.saldoFinal;

      let saldo = detalle.saldoInicial;
      let id = 0;
      state.movimientosDetalle = [];

      state.movimientosDetalle = detalle.movimientos.map((movimiento) => {
        saldo = saldo + movimiento.credito - movimiento.debito;
        movimiento.saldo = saldo;
        movimiento.numeroComprobante =
          movimiento.numeroComprobante === 0
            ? ""
            : `${movimiento.numeroComprobante}`;
        let expandir = false;
        id++;
        if (Array.isArray(movimiento.detalleVenta)) {
          expandir = movimiento.detalleVenta.length > 0 ? true : false;
        }
        if (expandir) {
          let listaDocumentoVenta = [
            ...new Set(
              movimiento.detalleVenta.map((detalle) => detalle.numeroDocumento)
            ),
          ];
          let listaDetallesPorDocumento = listaDocumentoVenta.map(
            (numeroDocumento) => {
              let detallesFiltrados = movimiento.detalleVenta.filter(
                (detalle) => detalle.numeroDocumento === numeroDocumento
              );
              return {
                detalles: detallesFiltrados,
                nombreDepartamento: detallesFiltrados[0].nombreDepartamento,
                numeroDocumento,
                fechaEmision: detallesFiltrados[0].fechaEmision,
                autorizado: detallesFiltrados[0].nombreAutorizado,
                moneda: detallesFiltrados[0].moneda,
              };
            }
          );
          movimiento.detalleVenta = listaDetallesPorDocumento;
        }
        return {
          movimiento,
          id,
          expandir,
        };
      });
    },
    setDetalleAnterior(state, detalle) {
      let saldoInicial = detalle.saldoInicial;
      let debitoFecha = 0;
      let creditoFecha = 0;
      let data = [];
      let dataDebito = [];
      let dataCredito = [];
      for (let index = 0; index < 31; index++) {
        let movimientosPorFecha = detalle.movimientos.filter(
          (mov) =>
            parseInt(mov.fechaOperacion.split("T")[0].split("-").pop()) ===
            index + 1
        );
        for (let j = 0; j < movimientosPorFecha.length; j++) {
          const mov = movimientosPorFecha[j];
          if (mov.credito !== 0) {
            creditoFecha += mov.credito;
          } else if (mov.debito !== 0) {
            debitoFecha += mov.debito;
          }
        }
        data[index] = saldoInicial + creditoFecha - debitoFecha;
        if (movimientosPorFecha.length !== 0) {
          dataDebito[index] = debitoFecha;
          dataCredito[index] = creditoFecha;
        } else {
          dataDebito[index] = null;
          dataCredito[index] = null;
        }
      }

      state.detalleChartAnterior = { data: data };
      state.detalleDebitoAnterior = { data: dataDebito };
      state.detalleCreditoAnterior = { data: dataCredito };
    },
    setDetalleActual(state, datos) {
      let detalle = datos.detalle;
      let saldoInicial = detalle.saldoInicial;
      let todayDate = new Date().toISOString().slice(0, 10).split("-");
      let day = parseInt(todayDate.pop());
      let month = todayDate[1];
      let monthPeriodo = datos.periodo.toString().slice(4);
      let labels = [];
      let debitoFecha = 0;
      let creditoFecha = 0;
      let data = [];
      let dataDebito = [];
      let dataCredito = [];
      for (let index = 0; index < 31; index++) {
        if (month != monthPeriodo || index + 1 <= day) {
          let movimientosPorFecha = detalle.movimientos.filter(
            (mov) =>
              parseInt(mov.fechaOperacion.split("T")[0].split("-").pop()) ===
              index + 1
          );
          for (let j = 0; j < movimientosPorFecha.length; j++) {
            const mov = movimientosPorFecha[j];
            if (mov.credito !== 0) {
              creditoFecha += mov.credito;
            } else if (mov.debito !== 0) {
              debitoFecha += mov.debito;
            }
          }
          data[index] = saldoInicial + creditoFecha - debitoFecha;
          if (movimientosPorFecha.length !== 0) {
            dataDebito[index] = debitoFecha;
            dataCredito[index] = creditoFecha;
          } else {
            dataDebito[index] = null;
            dataCredito[index] = null;
          }
        } else {
          data[index] = null;
        }
        labels[index] = `${index + 1}`;
      }
      state.detalleChartActual = { data: data };
      state.detalleDebitoActual = { data: dataDebito };
      state.detalleCreditoActual = { data: dataCredito };
      state.chartDetalleLabels = labels;
    },
    setResumenMensualChart(state, datos) {
      let tempCredito = datos.filter((mov) => mov.totalCredito !== 0);
      let creditoLabels = tempCredito.map((mov) => mov.abreviatura);
      let creditoData = tempCredito.map((mov) => mov.totalCredito);
      let tempDebito = datos.filter((mov) => mov.totalDebito !== 0);
      let debitoLabels = tempDebito.map((mov) => mov.abreviatura);
      let debitoData = tempDebito.map((mov) => mov.totalDebito);

      state.chartResumenMensualCreditoLables = creditoLabels;
      state.chartResumenMensualDebitoLables = debitoLabels;
      state.chartResumenMensualCreditoChart = creditoData;
      state.chartResumenMensualDebitoChart = debitoData;
    },
    setResumenAnualChart(state, datos) {
      let tempCredito = datos.filter((mov) => mov.totalCredito !== 0);
      let creditoLabels = tempCredito.map((mov) => mov.abreviatura);
      let creditoData = tempCredito.map((mov) => mov.totalCredito);
      let tempDebito = datos.filter((mov) => mov.totalDebito !== 0);
      let debitoLabels = tempDebito.map((mov) => mov.abreviatura);
      let debitoData = tempDebito.map((mov) => mov.totalDebito);

      state.chartResumenAnualCreditoLables = creditoLabels;
      state.chartResumenAnualDebitoLables = debitoLabels;
      state.chartResumenAnualCreditoChart = creditoData;
      state.chartResumenAnualDebitoChart = debitoData;
    },
    setResumen(state, resumen) {
      state.movimientosResumen = resumen.movimientos;
      state.saldoInicialResumen = resumen.saldoInicial;
      state.saldoFinalResumen = resumen.saldoFinal;
    },
    setResumenAnual(state, resumen) {
      state.movimientosAnual = resumen.movimientos;
      state.saldoInicialAnual = resumen.saldoInicial;
      state.saldoFinalAnual = resumen.saldoFinal;
      state.totalCredito = resumen.totalCredito;
      state.totalDebito = resumen.totalDebito;
    },
    clearChartData(state) {
      state.detalleChartActual = null;
      state.detalleChartAnterior = null;
      state.detalleDebitoActual = null;
      state.detalleCreditoActual = null;
      state.detalleCreditoAnterior = null;
      state.detalleDebitoAnterior = null;
    },
    clearResumenChartData(state) {
      state.chartResumenMensualCreditoLables = [];
      state.chartResumenMensualDebitoLables = [];
      state.chartResumenMensualCreditoChart = null;
      state.chartResumenMensualDebitoChart = null;
      state.chartResumenAnualCreditoLables = [];
      state.chartResumenAnualDebitoLables = [];
      state.chartResumenAnualCreditoChart = null;
      state.chartResumenAnualDebitoChart = null;
    },
  },
  actions: {
    async fetchDetalle({ commit }, [idCuenta, periodo]) {
      commit("clearChartData");
      let detalle = await CuentaRepository.detalle(idCuenta, periodo);
      commit("setDetalle", detalle);
      commit("setDetalleActual", { detalle: detalle, periodo: periodo });
    },
    async fetchDetalleMesAnterior({ commit }, [idCuenta, periodo]) {
      let periodoString = periodo.toString();
      if (periodoString.length !== 0) {
        let year = periodo.toString().substring(0, 4);
        let month = periodo.toString().substring(4, 6);
        let periodoAnteriorDate = new Date(
          parseInt(year),
          parseInt(month) - 2,
          1
        );
        periodoAnteriorDate = periodoAnteriorDate.toISOString().split("-");
        let periodoAnterior = `${periodoAnteriorDate[0]}${periodoAnteriorDate[1]}`;
        let detalle = await CuentaRepository.detalle(idCuenta, periodoAnterior);
        commit("setDetalleAnterior", detalle);
      }
    },
    async fetchResumen({ commit }, [idCuenta, periodo]) {
      commit("clearResumenChartData");
      let resumen = await CuentaRepository.resumen(idCuenta, periodo);
      commit("setResumen", resumen);
      commit("setResumenMensualChart", resumen.movimientos);
    },
    async fetchResumenAnual({ commit }, [idCuenta, anio]) {
      commit("clearResumenChartData");
      let resumen = await CuentaRepository.resumenAnual(idCuenta, anio);
      commit("setResumenAnual", resumen);
      commit("setResumenAnualChart", resumen.movimientos);
    },
    async downloadExtracto(_, [idCuenta, periodo]) {
      return await CuentaRepository.extracto(idCuenta, periodo);
    },
    async fetchHistorialSaldo(_, [idCuenta]) {
      return await CuentaRepository.historialSaldo(idCuenta)
    },
  },
};
